import React from "react";
import { Box, styled } from "@mui/material";
import StepIndicator from "./StepIndicator";

const StepProgress = ({ numSteps, activeStep, steps }) => (
  <StyledStepProgress>
    {Array.from({ length: numSteps }, (_, stepNum) => (
      <StepIndicator
        key={stepNum}
        active={activeStep === stepNum && !steps[stepNum].disabled}
        completed={activeStep > stepNum}
        number={stepNum + 1}
        disabled={steps[stepNum].disabled}
        nextDisabled={steps[stepNum + 1]?.disabled}
        tooltipText={steps[stepNum].tooltipText}
        isLast={stepNum === numSteps - 1}
        label={steps[stepNum].label}
      />
    ))}
  </StyledStepProgress>
);

export default StepProgress;

const StyledStepProgress = styled(Box)(() => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "center"
}));
